import React, { useContext, useEffect, useState, useRef, useCallback } from 'react'
import { BI_AUT004Context } from '../context'
import { Button } from 'reactstrap'
import getCroppedImg from '../../../components/Utils/cropUtils'
import { Skeleton } from 'primereact/skeleton'
import Cropper from 'react-easy-crop'

export default function GridBody() {
  const {
    inputs,
    handleUpload,
    handleRemove,
  } = useContext(BI_AUT004Context)

  const [imageSrc, setImageSrc] = useState(inputs?.Imagem || "");
  const [croppedBlob, setCroppedBlob] = useState(null);
  const [isNewImage, setIsNewImage] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const inputRef = useRef();

  const renderPlaceholder = (size) => (
    <i
      className="far fa-user-circle user-photo-label"
      style={{
        width: size,
        height: size,
        fontSize: size,
        color: '#ccc',
        textAlign: 'center',
        lineHeight: `${size}px`
      }}
      aria-hidden="true"
    />
  );

  const triggerFileSelect = e => {
    e.stopPropagation();
    inputRef.current.click();
  };

  const handleConfirmCrop = useCallback(async () => {
    try {
      const blob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedBlob(blob);
      setIsNewImage(false);
    } catch (err) {
      console.error(err);
    }
  }, [imageSrc, croppedAreaPixels]);

  const onFileChange = async e => {
    const file = e.target.files[0];
    if (!file) return;

    e.target.value = null;

    setImageSrc(URL.createObjectURL(file));
    setIsNewImage(true);
    setCrop({ x: 0, y: 0 });
    setZoom(2);
  };

  const onCropComplete = useCallback((_, pixels) => setCroppedAreaPixels(pixels), []);

  const handleSave = async e => {
    e.preventDefault();
    if (!croppedBlob) return;
    setIsSaving(true);

    const compressed = await (async blob => {
      const img = await createImageBitmap(blob);
      const canvas = document.createElement('canvas');
      const maxSize = inputs.Crop;
      let { width: w, height: h } = img;
      if (w > h && w > maxSize) { h *= maxSize / w; w = maxSize; }
      if (h >= w && h > maxSize) { w *= maxSize / h; h = maxSize; }
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      return new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.7));
    })(croppedBlob);

    const reader = new FileReader();
    reader.onloadend = () => {
      handleUpload(reader.result);
      setIsSaving(false);
    };
    reader.readAsDataURL(compressed);
  };

  useEffect(() => {
    if (!croppedBlob) return;
    const url = URL.createObjectURL(croppedBlob);
    setPreviewUrl(url);
  }, [croppedBlob]);

  return (
    <>
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={onFileChange}
      />

      <div className="d-flex flex-column justify-content-center h-100 align-items-center">
        <form className="w-100" onSubmit={handleSave}>
          <div className="text-center" style={{
            padding: "0",
            margin: "0",
            width: "100%",
          }}>
            {isSaving ? (
              <Skeleton width="100%" height={300} />
            ) : !croppedBlob ? (
              !isNewImage ? (
                <>
                  <div className="d-flex justify-content-center align-items-end gap-5 mb-4">
                    
                    <div className="d-flex flex-column align-items-center gap-2">
                      {imageSrc ? (
                        <img
                          src={imageSrc}
                          alt={inputs.Nome_Completo}
                          className="rounded-circle"
                          style={{ width: 170, height: 170, objectFit: 'cover'}}
                        />
                      ) : (
                        renderPlaceholder(170)
                      )}
                      <span className="font-w-600 font-size-16 text-color-azul2 mt-1">Versão completa</span>
                    </div>


                    <div className="d-flex flex-column align-items-center mb-0 gap-2">
                      {imageSrc ? (
                        <img
                          src={imageSrc}
                          alt={inputs.Nome_Completo}
                          className="rounded-circle"
                          style={{ width: 32, height: 32, objectFit: 'cover' }}
                        />
                      ) : (
                        renderPlaceholder(32)
                      )}
                      <span className="font-w-600 font-size-16 text-color-azul2">Versão miniatura</span>
                    </div>
                  </div>

                  <p className="fw-light gray-700-text pb-2">
                    A imagem deve estar nos formatos <strong className="fw-bold">PNG, JPEG ou WEBP</strong>, com resolução de <strong className="fw-bold">{inputs?.Crop_Info} pixels</strong><br /> e tamanho máximo de <strong className="fw-bold">2MB</strong>.
                  </p>
                </>
              ) : (
                <>
                  <div
                    className="crop-container mb-3 w-100 d-flex justify-content-center align-items-center relative"
                    style={{ height: '320px', position: 'relative', borderRadius: 12 }}
                  >
                      <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        cropShape="round"
                        showGrid={false}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropComplete}
                      />
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
                    <label htmlFor="zoomRange" className="mb-0">Zoom:</label>
                    <input
                      id="zoomRange"
                      className='zoomRange'
                      type="range"
                      min={1}
                      max={3}
                      step={0.1}
                      value={zoom}
                      onChange={e => setZoom(Number(e.target.value))}
                      style={{background: `linear-gradient(to right, #244EA2 ${((zoom - 1) / (3 - 1)) * 100}%, #dee2e6 ${((zoom - 1) / (3 - 1)) * 100}%)`}}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <span className="font-size-14 text-color-cinza4 font-w-400">Posicione a foto dentro do corte conforme<br /> a sua preferência.</span>
                  </div>
                </>
              )
            ) : (
              <>
                <div className="d-flex justify-content-center align-items-end gap-4 mb-4">

                  <div className="d-flex flex-column align-items-center gap-2">
                    <img
                      src={previewUrl}
                      alt={inputs.Nome_Completo}
                      className="rounded-circle"
                      style={{ width: 170, height: 170, objectFit: 'cover', border: '1px solid #ddd' }}
                    />
                    <span className="font-w-600 text-color-azul2 mt-1">Versão completa</span>
                  </div>

                  <div className="d-flex flex-column align-items-center mb-0 gap-2">
                    <img
                      src={previewUrl}
                      alt={inputs.Nome_Completo}
                      className="rounded-circle"
                      style={{ width: 32, height: 32, objectFit: 'cover', border: '1px solid #ddd' }}
                    />
                    <span className="font-w-600 text-color-azul2">Versão miniatura</span>
                  </div>
                </div>
                <p className="font-size-16 text-color-cinza5 font-w-300 mb-4">
                  Esta é uma prévia de como será exibida a foto dentro <br /> da plataforma <strong className="text-color-azul3 font-w-600">Business Integrator</strong>.
                </p>
              </>
            )}

          </div>

          <div className="d-flex justify-content-center">

            {!croppedBlob && !isNewImage && (
              <>
              {imageSrc?.length > 0 && (                
                <button
                  type="button"
                  style={{borderRadius: 10}}
                  className="mx-2 btn border-none bg-transparent px-4 p-3 text-color-azul2 font-size-16 font-w-600"
                  onClick={(e) => handleRemove()}
                >
                  Excluir
                </button>
              )}

                <Button
                  type="button"
                  style={{borderRadius: 10}}
                  className="mx-2 btn-primary-dark px-4 p-3 bg-color-azul2 font-size-16 font-w-600"
                  onClick={triggerFileSelect}
                >
                  Carregar
                </Button>
              </>
            )}

            {isNewImage && !croppedBlob && (
              <>
                <Button color="link" className="primary-dark hover-red waves-effect mx-2"
                  disabled={isSaving}
                  onClick={() => { 
                    setIsNewImage(false); 
                    setCroppedBlob(null);
                    setImageSrc(inputs.Foto_Usuario)
                  }}
                  >
                  Cancelar
                </Button>
                <Button
                  type="button"
                  style={{borderRadius: 10}}
                  className="mx-2 btn-primary-dark px-4 p-3 bg-color-azul2 font-size-16 font-w-600"
                  onClick={() => handleConfirmCrop()}
                  disabled={!croppedAreaPixels}
                >
                  Cortar
                </Button>
              </>
            )}

            {croppedBlob && (
              <>
                <Button
                  type="button"
                  color="link"
                  className="primary-dark waves-effect mx-2"
                  onClick={() => { setCroppedBlob(null); setIsNewImage(true); }}
                  disabled={isSaving}
                >
                  Voltar
                </Button>
                <Button type='submit'
                  style={{borderRadius: 10}}
                  className="mx-2 btn-primary-dark px-4 p-3 bg-color-azul2 font-size-16 font-w-600">
                  Salvar
                </Button>
              </>
            )}
          </div>

        </form>
      </div>
    </>
  )
}